// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll-loader__wrapper{position:relative}.scroll-loader__wrapper_grid{display:grid;grid-template-columns:repeat(3,1fr)}.scroll-loader__preloader{display:flex;align-items:center;justify-content:center;padding:12px}.scroll-loader__preloader_absolute{position:absolute;top:100%;left:50%;transform:translateX(-50%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
